import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { store } from '~state/ReduxWrapper';
import { useSelector, useDispatch } from 'react-redux';

import useAsyncDefault from '~components/forms/useAsyncDefault';
import {
  prepareDataForSubmit,
  handleSubmitError,
  defaultErrorState,
} from '~components/forms/SubmissionHelpers';
import axios from '~utils/axios';
import updatePersonFields from '~actions/updatePersonFields';

import IntakeForm from '~components/forms/intakes/IntakeForm';
import { handleRegisterPostResult } from './navigateToSecondStep';
import updateDataLayer from '../../utils/events';

function RegisterForm({ initialh1, isEmbed }) {
  const dispatch = useDispatch();
  const person = useSelector((state) => state.person);
  const sourcing = useSelector((state) => state.sourcing);
  const registerFields = useSelector((state) => state.registerFields);

  const { subscriber } = sourcing;

  const [formError, setFormError] = useState(defaultErrorState);

  const [initialValues, setInitialValues] = useState({
    first_name: person.first_name,
    last_name: person.last_name,
    address1: person.address1,
    address2: person.address2,
    city: person.city,
    state: person.state,
    zipcode: person.zipcode,
    month_of_birth: person.month_of_birth,
    day_of_birth: person.day_of_birth,
    year_of_birth: person.year_of_birth,
    email: person.email,
    phone: person.phone,
    sms_opt_in_subscriber: registerFields.sms_opt_in_subscriber,
    sms_opt_in_voteamerica: registerFields.sms_opt_in_voteamerica,
  });

  useAsyncDefault(
    'sms_opt_in_subscriber',
    setInitialValues,
    (state) => state.registerFields.sms_opt_in_subscriber
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (formData) => {
    setIsSubmitting(true);

    updateDataLayer({
      event: 'action-start',
      tool: 'register',
      state: formData.state,
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      zipcode: formData.zipcode,
      method: undefined,
      url: undefined,
    });

    const submitData = prepareDataForSubmit(formData);

    try {
      if (registerFields.uuid && registerFields.referring_tool) {
        const [{ data }] = await Promise.all([
          axios.patch(
            `registration/register/${registerFields.uuid}/?incomplete=true&match_region=true&subscriber=${subscriber}`,
            submitData
          ),
          dispatch(updatePersonFields(formData)),
        ]);
        store.dispatch({
          type: 'REGISTER_UPDATE_FIELDS',
          registerFields: {
            referring_tool: '',
          },
        });
        handleRegisterPostResult(submitData, data);
      } else {
        const [{ data }] = await Promise.all([
          axios.post(
            `registration/register/?incomplete=true&match_region=true&subscriber=${subscriber}`,
            submitData
          ),
          dispatch(updatePersonFields(formData)),
        ]);
        handleRegisterPostResult(submitData, data);
      }
    } catch (error) {
      handleSubmitError(error, formData, setFormError);
    }

    setIsSubmitting(false);
  };

  return (
    <IntakeForm
      formId='register'
      submitButtonId='register-start'
      formError={formError}
      initialh1={initialh1}
      isSubmitting={isSubmitting}
      onSubmit={onSubmit}
      initialValues={initialValues}
      isRestorationDisclaimerDisplayed
      isEmbed={isEmbed}
    />
  );
}

RegisterForm.propTypes = {
  initialh1: PropTypes.string,
  isEmbed: PropTypes.bool,
};

export default RegisterForm;
